<template>
    <div
        :class="{ [`lam-loader-${size}`]: true, [`lam-loader-${color}`]: true }"
        class="lam-loader loader"
    >
        <div>
            <span v-if="size === 'lg'">{{ title }}</span>
            <ul>
                <li class="uk-width-5-18"></li>
                <li class="uk-width-3-18"></li>
                <li class="uk-width-2-18"></li>
                <li v-if="size.match(/^(md|lg)$/i)" class="uk-width-1-18"></li>
                <li v-if="size.match(/^(md|lg)$/i)" class="uk-width-3-18"></li>
                <li v-if="size.match(/^(md|lg)$/i)" class="uk-width-4-18"></li>
            </ul>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        title: {
            type: String,
            default: window.nibnut.vue.application_official_name
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(xs|sm|md|lg)$/),
            default: "md"
        },
        color: {
            type: String,
            validator: prop => !prop || !!prop.match(/^(gray|light|primary)$/),
            default: "primary"
        }
    }
}
</script>

<style lang="less">
@import "@/assets/less/variables";

.lam-loader {
    position: relative;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    z-index: 5000;
    clear: left;

    & > div {
        position: absolute;
        top: 50%;
        margin-bottom: -50%;
        left: 50%;
        margin-right: -50%;
        -ms-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        font-size: 3em;
        font-family: @base-heading-font-family;
        line-height: 1.5em;

        ul {
            padding-left: 0;
            & > li {
                background-color: @global-lam-orange;
                list-style: none;
                padding-left: 0;

                @width: 4px;
                float: left;
                margin-left: @width;
                width: @width;
                height: (2 * @width);

                &.uk-width-2-18 {
                    width: (2 * @width);
                }
                &.uk-width-3-18 {
                    width: (3 * @width);
                }
                &.uk-width-4-18 {
                    width: (4 * @width);
                }
                &.uk-width-5-18 {
                    width: (5 * @width);
                }

                &:nth-child(6) {
                    -webkit-animation: loading 3s infinite ease-in-out;
                    animation: loading 3s infinite ease-in-out;
                }
                &:nth-child(5) {
                    -webkit-animation: loading 3s 100ms infinite ease-in-out;
                    animation: loading 3s 100ms infinite ease-in-out;
                }
                &:nth-child(4) {
                    -webkit-animation: loading 3s 200ms infinite ease-in-out;
                    animation: loading 3s 200ms infinite ease-in-out;
                }
                &:nth-child(3) {
                    -webkit-animation: loading 3s 300ms infinite ease-in-out;
                    animation: loading 3s 300ms infinite ease-in-out;
                }
                &:nth-child(2) {
                    -webkit-animation: loading 3s 400ms infinite ease-in-out;
                    animation: loading 3s 400ms infinite ease-in-out;
                }
                &:nth-child(1) {
                    -webkit-animation: loading 3s 500ms infinite ease-in-out;
                    animation: loading 3s 500ms infinite ease-in-out;
                    margin-left: 0;
                }
            }
        }
    }

    &.lam-loader-xs {

    }
    &.lam-loader-sm {
        min-height: 6px;

        & > div {
            font-size: 1.5em;
            font-family: @base-heading-font-family;
            line-height: 0.75em;

            ul {
                margin: 0;

                & > li {
                    @width: 3px;
                    margin-top: 0;
                    margin-left: @width;
                    width: @width;
                    height: (2 * @width);

                    &.uk-width-2-18 {
                        width: (2 * @width);
                    }
                    &.uk-width-3-18 {
                        width: (3 * @width);
                    }
                    &.uk-width-4-18 {
                        width: (4 * @width);
                    }
                    &.uk-width-5-18 {
                        width: (5 * @width);
                    }
                }
            }
        }
    }
    &.lam-loader-gray {
        & > div {
            ul {
                & > li {
                    background-color: @global-lam-gray;
                }
            }
        }
    }
    &.lam-loader-light {
        & > div {
            ul {
                & > li {
                    background-color: @global-lam-blue;
                }
            }
        }
    }
}
@keyframes loading {
    0% {
        opacity: 0;
        transform: translateX(-300px);
    }
    33% {
        opacity: 1;
        transform: translateX(0px);
    }
    66% {
        opacity: 1;
        transform: translateX(0px);
    }
    100% {
        opacity: 0;
        transform: translateX(300px);
    }
}
</style>
